import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
window.tippy = tippy;
